<template>
  <div class="setting-post-time-page">
    <ins-selector v-model="selectPublisherId"></ins-selector>
    <div class="right-container">
      <div class="header-container"></div>
      <div class="main-container">
        <div class="types-view" ref="repost">
          <div class="header-title">Repost Caption</div>
          <div
            class="radio-type-container"
            @click="switchRadio(type.id)"
            :class="{ select: type.select }"
            v-for="type in types"
            :key="type.id"
          >
            <div class="text">{{ type.text }}</div>
            <div class="icon"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";
import insSelector from "../../components/common/instagram_selector/Selector";
import { updateUserInfo } from "../../service/user";
import { updatePublisher } from "../../service/publisher";
import { showErrorMsg } from "../../utils/errors";
import _ from "lodash";

export default {
  name: "SettingManagerSearchPage",
  components: { insSelector },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
  },
  data() {
    return {
      selectPublisherId: "",
      types: [
        { id: 0, text: `Keep “Repost from @username”`, select: false },
        { id: 1, text: `Keep original caption`, select: false },
        {
          id: 2,
          text: `Keep “Repost from @username” and original caption`,
          select: false,
        },
        { id: 3, text: `Empty (I will use my own caption)`, select: false },
      ],
    };
  },
  methods: {
    /**
     * 切换radio
     * @param id
     */
    async switchRadio(id) {
      const loading = this.$loading({ target: this.$refs.repost });
      const copy = _.cloneDeep(this.types);
      try {
        this.types.forEach((type) => {
          type.select = false;
        });
        this.types.find((t) => t.id === id).select = true;
        await updatePublisher({
          repost_caption_choice: id,
          publisherId: this.selectPublisherId,
        });
      } catch (e) {
        showErrorMsg(e);
        this.$set(this, "types", copy);
      } finally {
        loading.close();
      }
    },
    async reload() {
      const loading = this.$loading({ target: this.$refs.repost });
      try {
        await updateUserInfo({});
        // 重新更新选中逻辑
        const selectPublisher = this.user.linkedInstagramList.find(
          (link) => link.publisherId === this.selectPublisherId
        );
        this.types.forEach((type) => {
          type.select = false;
        });
        this.types.find(
          (t) => t.id === selectPublisher.repostCaptionChoice
        ).select = true;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
  },
  watch: {
    selectPublisherId: {
      async handler(val) {
        if (!val) {
          return;
        }
        this.reload();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style scoped lang="less">
@import "../../assets/style/theme.less";

.setting-post-time-page {
  display: flex;
  flex: 1;

  .right-container {
    flex: 1;
    height: 100vh;
    .header-container {
      height: 80px;
      border-bottom: 1px solid @border-color;
    }
    .main-container {
      display: flex;
      flex-direction: column;
      height: calc(~"100vh - 80px");
      overflow: auto;
      padding: 0 40px;
      .types-view {
        min-width: 700px;
        .header-title {
          font-size: 20px;
          font-weight: 500;
          margin-top: 50px;
          margin-bottom: 20px;
        }
        .radio-type-container {
          display: flex;
          justify-content: space-between;
          height: 44px;
          align-items: center;
          cursor: pointer;
          &.select {
            .icon {
              background-image: url(../../../public/images/bulk/checkbox_checked_disable@3x.png);
            }
          }
          &:hover,
          &:active {
            opacity: 0.7;
          }
          .text {
          }
          .icon {
            width: 24px;
            height: 24px;
            background-image: url(../../../public/images/bulk/checkbox_checked_able@3x.png);
            background-size: contain;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
